import { getCloudPACSToken } from "@custom/Utils/authUtils";
import { _machineUrls, _PacsEditTagsUrls } from "@custom/Utils/constants/apiUrls";
import { ApiResponse, MachineProps } from "@custom/Utils/constants/interfaces";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const deleteMachineApi = {
    deleteSelectedMachineSlice: createAsyncThunk(
        "machine/delete",
        async (props: MachineProps, { rejectWithValue }) => {
            const pacs_token = getCloudPACSToken();
            try {
                const response = await fetch(
                    _machineUrls.delete(props.deviceName),
                    {
                        method: 'DELETE',
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${pacs_token}`,
                        },
                    }
                );

                if (!response.ok) {
                    throw new Error('Failed to update patient tags');
                }

                const data: ApiResponse<any> = await response.json();
                return data;
            } catch (error) {
                return rejectWithValue(error);
            }
        }
    ),
};
